import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
  Blockquote,
  BulletList,
  CodeBlock,
  HardBreak,
  Heading,
  ListItem,
  OrderedList,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
} from 'tiptap-extensions'
import BoldButton from '@/components/buttons/richmenu/BoldButton'
import ItalicButton from '@/components/buttons/richmenu/ItalicButton'
import UnderlineButton from '@/components/buttons/richmenu/UnderlineButton'
import StrikethroughButton from '@/components/buttons/richmenu/StrikethroughButton'
import ParagraphButton from '@/components/buttons/richmenu/ParagraphButton'
import H1Button from '@/components/buttons/richmenu/H1Button'
import H2Button from '@/components/buttons/richmenu/H2Button'
import H3Button from '@/components/buttons/richmenu/H3Button'
import BulletListButton from '@/components/buttons/richmenu/BulletListButton'
import NumberListButton from '@/components/buttons/richmenu/NumberListButton'
import BlockQuoteButton from '@/components/buttons/richmenu/BlockQuoteButton'
import Component from 'vue-class-component'
import Vue from 'vue'

@Component({
  name: 'richText',
  props: ['content'],
  components: {
    EditorContent,
    EditorMenuBar,
    BoldButton,
    ItalicButton,
    UnderlineButton,
    StrikethroughButton,
    ParagraphButton,
    H1Button,
    H2Button,
    H3Button,
    BulletListButton,
    NumberListButton,
    BlockQuoteButton,
  }
})
export default class RichText extends Vue {

  private theEditor = new Editor({
    extensions: [
      new Blockquote(),
      new BulletList(),
      new CodeBlock(),
      new HardBreak(),
      new Heading({ levels: [1, 2, 3] }),
      new ListItem(),
      new OrderedList(),
      new TodoItem(),
      new TodoList(),
      new Bold(),
      new Code(),
      new Italic(),
      new Link(),
      new Strike(),
      new Underline(),
      new History(),
    ],
    // content: this.theContent,
  })

  get editor() {
    return this.theEditor
  }

  beforeDestroy() {
    this.editor.destroy()
  }
}
